import { render } from "./NewArrival.vue?vue&type=template&id=1dc0bea4"
import script from "./NewArrival.vue?vue&type=script&lang=js"
export * from "./NewArrival.vue?vue&type=script&lang=js"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__